import { ICellRendererParams } from "ag-grid-community";
import { classHOC } from "components/app/ClassWrapper";
import { RANK_VALUE_LIST } from "constant";
import React, { FC, useEffect, useState } from "react";
import { currencyFormatter } from "utils";

const GroupRenderer: FC<ICellRendererParams & { groupCol: string }> = ({
  node,
  data,
  groupCol,
}) => {
  const [width, setWidth] = useState(`${document.body.clientWidth! - 200}px`);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(document.body.clientWidth - 280);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setWidth(`${document.body.clientWidth! - 280}px`);
  }, [width, windowWidth]);

  const handleGroupName = (groupCol: string) => {
    switch (groupCol) {
      case "ciscoCsm":
        return data?.groupName ?? "None";
      case "alertGroup":
        return RANK_VALUE_LIST?.find((i) => data?.groupName === i.id)?.risk || "No Health Rank";
      case "expandPlanRiskAssessment":
        return data?.groupName || "Not Set";
      default:
        return data?.groupName ?? "N/A";
    }
  };

  return (
    <div className="wrapper">
      {node.group ? (
        <div
          style={{
            width: width,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ fontWeight: "bold" }}>
              {handleGroupName(groupCol)} ({data?.count ?? 0})
            </span>
          </div>
          <div style={{ float: "right" }}>
            <span style={{ marginRight: 5, color: "#898989" }}>Invoice ARR Cloud: </span>
            <span style={{ fontWeight: "bold", color: "#007AA3" }}>
              {currencyFormatter(data?.invoiceArrCloud)}
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span style={{ marginRight: 5, color: "#898989" }}>Invoice ARR On-Prem: </span>
            <span style={{ fontWeight: "bold", color: "#007AA3" }}>
              {currencyFormatter(data?.invoiceArrOnPrem)}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
};
export default classHOC(GroupRenderer);
